import { useQuery } from '@tanstack/react-query';
import { useRestaurantContext } from '../context/RestaurantContext';
import { useUserContext } from '../context/UserContext';
import { getGuestVipTier } from '../restaurant/apiHelpers';

export const useGuestVipTier = () => {
  const { restaurantDetails } = useRestaurantContext();
  const { isAuthenticated } = useUserContext();

  const query = useQuery({
    queryKey: ['restaurants', restaurantDetails.id, 'guestVipTier'],
    queryFn: async () => {
      const response = await getGuestVipTier(restaurantDetails.id);
      return response.guestVipTier;
    },
    enabled: Boolean(restaurantDetails.id) && isAuthenticated,
  });

  return {
    guestVipTier: query.data ?? null,
    isGuestVipTierLoading: query.isLoading,
  };
};
